import React from 'react';
import { Alert, Button } from 'antd';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Erro na tela:', error, info);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <Alert
        type="error"
        showIcon
        message="Esta tela encontrou um erro"
        description="Atualize a pagina. Se continuar, abra o console do navegador e envie o erro para suporte."
        action={
          <Button size="small" danger onClick={() => window.location.reload()}>
            Recarregar
          </Button>
        }
      />
    );
  }
}
